module.exports = __webpack_public_path__ + "static/room3-1-0b2376bcb1dc2e71064a014ff650abeb.jpg";